import request from "./client";

export type AdminProfile = {
  id: number;
  full_name: string;
  email: string;
  role: "admin" | "manager" | "inspector" | "file_viewer";
};

export type AdminUser = {
  id: number;
  full_name: string;
  email: string;
  role: "admin" | "manager" | "inspector" | "file_viewer";
  is_active: boolean;
  last_login_at: string | null;
  created_at: string;
};

export async function loginUser(email: string, password: string) {
  return request<{
    token: string;
    user: {
      id: number;
      email: string;
      name: string;
      role: "admin" | "manager" | "inspector" | "file_viewer";
    };
  }>("/api/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export async function getAdminProfile() {
  return request<AdminProfile>("/api/admin/profile");
}

export async function updateAdminProfile(payload: {
  full_name?: string;
  email?: string;
  password?: string;
}) {
  return request<AdminProfile>("/api/admin/profile", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function getAdminUsers() {
  return request<AdminUser[]>("/api/admin/users");
}

export async function createAdminUser(payload: {
  full_name: string;
  email: string;
  password: string;
  role: AdminUser["role"];
}) {
  return request<AdminUser>("/api/admin/users", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function setAdminUserActive(id: number, is_active: boolean) {
  return request<AdminUser>(`/api/admin/users/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ is_active }),
  });
}

export async function updateAdminUser(
  id: number,
  payload: Partial<{
    full_name: string;
    email: string;
    password: string;
    role: AdminUser["role"];
    is_active: boolean;
  }>,
) {
  return request<AdminUser>(`/api/admin/users/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function deleteAdminUser(id: number) {
  return request<void>(`/api/admin/users/${id}`, { method: "DELETE" });
}
